import React, { useCallback } from 'react'
import PropTypes from 'prop-types'

import Checkbox from '../../../../../../../components/Form/Checkbox'
import ErrorMessage from '../../../../../../../components/Form/ErrorMessage'

import {
  AGE_13_17,
  AGE_18_24,
  AGE_25_34,
  AGE_35_44,
  AGE_45_54,
  AGE_55_100,
  CUSTOM_AGE_RANGES
} from '../../../../../../ReusableFormFields/AgeRangesFields/fields'

const TiktokCustomAgeRanges = ({ formik, isLarge = true }) => {
  const { values, errors, touched, setFieldValue } = formik

  const checkCustomAgeRangeHandler = useCallback(
    e => {
      setFieldValue(CUSTOM_AGE_RANGES, {
        ...values[CUSTOM_AGE_RANGES],
        [e.target.name]: !values[CUSTOM_AGE_RANGES][e.target.name]
      })
    },
    [setFieldValue, values]
  )
  return (
    <>
      <Checkbox
        id="checkbox_age_13_17"
        title="13-17"
        isLarge={isLarge}
        name={AGE_13_17}
        checked={values[CUSTOM_AGE_RANGES][AGE_13_17]}
        onCheck={checkCustomAgeRangeHandler}
      />
      <Checkbox
        id="checkbox_age_18_24"
        title="18-24"
        isLarge={isLarge}
        name={AGE_18_24}
        checked={values[CUSTOM_AGE_RANGES][AGE_18_24]}
        onCheck={checkCustomAgeRangeHandler}
      />
      <Checkbox
        id="checkbox_age_25_34"
        title="25-34"
        isLarge={isLarge}
        name={AGE_25_34}
        checked={values[CUSTOM_AGE_RANGES][AGE_25_34]}
        onCheck={checkCustomAgeRangeHandler}
      />
      <Checkbox
        id="checkbox_age_35_44"
        title="35-44"
        isLarge={isLarge}
        name={AGE_35_44}
        checked={values[CUSTOM_AGE_RANGES][AGE_35_44]}
        onCheck={checkCustomAgeRangeHandler}
      />
      <Checkbox
        id="checkbox_age_45_54"
        title="45-54"
        isLarge={isLarge}
        name={AGE_45_54}
        checked={values[CUSTOM_AGE_RANGES][AGE_45_54]}
        onCheck={checkCustomAgeRangeHandler}
      />
      <Checkbox
        id="checkbox_age_55_100"
        title="55+"
        isLarge={isLarge}
        name={AGE_55_100}
        checked={values[CUSTOM_AGE_RANGES][AGE_55_100]}
        onCheck={checkCustomAgeRangeHandler}
      />
      {touched[CUSTOM_AGE_RANGES] && errors[CUSTOM_AGE_RANGES] && <ErrorMessage error={errors[CUSTOM_AGE_RANGES]} />}
    </>
  )
}

TiktokCustomAgeRanges.propTypes = {
  isLarge: PropTypes.bool
}

export default TiktokCustomAgeRanges
